<ng-container *ngIf="loading; else componentContent">
  <mat-spinner color="primary" diameter="24"></mat-spinner>
</ng-container>
<ng-template #componentContent>
  <tour-item-registered
    [tourItem]="subProject?.tourItem"
  ></tour-item-registered>
  <div class="d-flex">
    <mat-form-field appearance="outline">
      <mat-select
        matInput
        placeholder="Installateur"
        name="placerSelector"
        [(ngModel)]="placer"
        (ngModelChange)="tourConfigurationChanged()"
        [compareWith]="compareEntities"
        [disabled]="subProject.onHold"
      >
        <mat-option *ngFor="let option of placerOptions" [value]="option">
          {{ option.user?.firstName | personName : option.user?.lastName }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="left-space" appearance="outline">
      <input
        matInput
        [min]="today"
        [matDatepicker]="tourDatePicker"
        placeholder="Datum"
        [(ngModel)]="date"
        (ngModelChange)="tourConfigurationChanged()"
        [disabled]="locked || subProject.onHold"
      />
      <mat-datepicker-toggle
        matSuffix
        [for]="tourDatePicker"
      ></mat-datepicker-toggle>
      <mat-datepicker #tourDatePicker></mat-datepicker>
    </mat-form-field>
    <div class="left-space align-lock-checkbox">
      <mat-checkbox
        [(ngModel)]="locked"
        (ngModelChange)="tourConfigurationChanged()"
        [disabled]="subProject.onHold"
        >LOCK</mat-checkbox
      >
    </div>
    <div *ngIf="placer != null && date != null" class="left-space">
      <button class="reset-button" mat-flat-button (click)="unassignFromTour()">
        Maak los van toer
      </button>
    </div>
  </div>
</ng-template>
